module.exports = __webpack_public_path__ + "static/media/gallery.7c9a6e70.svg";